import { Controller } from '@hotwired/stimulus'
import debounce from 'debounce'

export default class extends Controller {
  static values = {
    onload: Boolean,
  }

  static targets = ["searchIcon", "loadingIcon"]

  initialize() {
    if (this.hasOnloadValue && this.onloadValue) {
      setTimeout(() => {
        this.submit()
      }, 1500)
    }

    this.debouncedSubmit = debounce(this.debouncedSubmit.bind(this), 300)
    this.handleSubmitEnd = this.#handleSubmitEnd.bind(this)
  }

  connect() {
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  #handleSubmitEnd() {
    this.#hideLoading()
  }

  #showLoading() {
    if (this.hasSearchIconTarget && this.hasLoadingIconTarget) {
      this.searchIconTarget.classList.add('hidden')
      this.loadingIconTarget.classList.remove('hidden')
    }
  }

  #hideLoading() {
    if (this.hasSearchIconTarget && this.hasLoadingIconTarget) {
      this.searchIconTarget.classList.remove('hidden')
      this.loadingIconTarget.classList.add('hidden')
    }
  }

  preventToggle(e) {
    e.currentTarget.checked = !e.currentTarget.checked
  }

  confirmBeforeSubmit(e) {
    this.preventToggle(e)

    const dialog = document.getElementById("turbo_confirm")

    const { confirmTitle, confirmBody, confirmButtonText, cancelButtonText, confirmVariant } = e.target.dataset

    dialog.querySelector('[data-title]').innerText = confirmTitle
    dialog.querySelector('[data-body]').innerHTML = confirmBody
    dialog.querySelector('[data-confirm]').innerHTML = confirmButtonText
    dialog.querySelector('[data-cancel]').innerHTML = cancelButtonText
    dialog.setAttribute('data-variant', confirmVariant || 'destructive')

    dialog.classList.remove('hidden')
    dialog.showModal()
    dialog.focus()

    dialog.addEventListener("close", () => {
      if (dialog.returnValue === 'confirm') {
        e.target.checked = !e.target.checked
        this.submit(e)
      }

      dialog.classList.add('hidden')
      dialog.setAttribute('data-variant', 'destructive')
    }, { once: true })
  }

  submit() {
    this.#form().requestSubmit()
  }

  debouncedSubmit() {
    this.#showLoading()
    this.submit()
  }

  clearSearch() {
    this.debouncedSubmit.clear()

    const searchInput = this.#form().querySelector('input[type="text"]')
    if (searchInput) {
      searchInput.value = ''
      this.submit()
    }
  }

  #form() {
    const formId = this.element.getAttribute('form')
    if (formId) {
      return document.querySelector(`#${formId}`)
    } else {
      return this.element.closest('form')
    }
  }
}
